import { render, staticRenderFns } from "./DocumentPrintLicense.vue?vue&type=template&id=6983c526&scoped=true"
import script from "./DocumentPrintLicense.vue?vue&type=script&lang=js"
export * from "./DocumentPrintLicense.vue?vue&type=script&lang=js"
import style0 from "./DocumentPrintLicense.vue?vue&type=style&index=0&id=6983c526&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6983c526",
  null
  
)

export default component.exports